var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutterwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.892578 4.58733C0.892578 3.22766 1.29018 2.0668 2.12455 1.23242L3.57563 2.68351C1.96058 4.29276 3.37103 9.2961 7.96952 13.8989C12.568 18.5018 17.5742 19.9108 19.1878 18.2986L20.6389 19.7497C17.9167 22.4719 11.7162 20.5405 6.52569 15.3486C2.92555 11.747 0.892578 7.66072 0.892578 4.58733Z",
    fill: "#009A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0439 21.0007C8.68419 21.0007 7.52332 20.6031 6.6875 19.7687L8.13858 18.3177C9.75074 19.9298 14.7541 18.5194 19.3569 13.918C23.9598 9.31658 25.3673 4.31324 23.7552 2.70108L25.2062 1.25C27.9299 3.97223 25.9971 10.1727 20.8051 15.3632C17.2035 18.9692 13.1173 21.0007 10.0439 21.0007Z",
    fill: "#FF5805"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2861 13.2857C20.4053 10.7492 18.6059 8.03858 16.2189 5.653C11.0284 0.46102 4.82787 -1.47182 2.10564 1.25186C1.91265 1.44631 2.07952 1.92661 2.48002 2.32711C2.88052 2.72761 3.36083 2.89304 3.55382 2.70004C5.16743 1.08789 10.1708 2.49834 14.7722 7.10118C16.9488 9.27781 18.5711 11.7084 19.3532 13.9576C20.0381 15.9296 19.9714 17.52 19.1733 18.3181C18.9788 18.5111 19.1472 18.9928 19.5462 19.3919C19.9453 19.7909 20.427 19.9592 20.6215 19.7648C22.016 18.3703 22.2525 16.066 21.2861 13.2857Z",
    fill: "#F5AFCB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2023 1.25225C23.8049 -0.145144 21.5035 -0.38167 18.7203 0.586203C16.1853 1.46556 13.4732 3.26636 11.0876 5.65194C5.89709 10.8425 3.96425 17.0429 6.68648 19.7666C6.88093 19.9596 7.36124 19.7928 7.76174 19.3937C8.16223 18.9947 8.32911 18.5129 8.13466 18.3185C6.51816 16.7063 7.93296 11.703 12.5358 7.10012C14.7124 4.92349 17.143 3.30118 19.3922 2.51905C21.3642 1.83559 22.9546 1.90088 23.7541 2.69898C23.9471 2.89198 24.4289 2.7251 24.8279 2.3246C25.227 1.9241 25.3953 1.44524 25.2023 1.25225Z",
    fill: "#FF9B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutterwave);
export default __webpack_public_path__ + "static/media/flutterwave.abc607bb3caa040f6fdf017b320eeeca.svg";
export { ForwardRef as ReactComponent };